import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { hepSettingsApi } from "@/lib/api";
import type { HepSettingsUpdate } from "@/types";

export function useHepSettings() {
  return useQuery({
    queryKey: ["hep-settings"],
    queryFn: () => hepSettingsApi.get(),
  });
}

export function useUpdateHepSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: HepSettingsUpdate) => hepSettingsApi.update(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["hep-settings"] }),
  });
}
